var WebFont = require('webfontloader');

export default {
  init: function () {
    WebFont.load({
      custom: {
        families: ['Butler']
      },
      google: {
        families: ['Inter:300,400,500,600,700']
      }
    });
  },
};
